module.exports = __webpack_public_path__ + "static/media/IMG_0389.38f8d080.JPG";